import { Picker, List } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData, convertHtmlTag, convertTagStyle } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GoodsReturnInfor.less';

export default class GoodsReturnInfor extends OfficialPage {
  state = {
    goodsList: [],
    imagesArr: [],
    refundDes: '',
    shipment: '',
    phone: '',
    storeStyle: {}
  }
  applyId = ''
  orderId = ''
  franchiseeId = ''
  refundGoods = []
  expressList = []

  constructor(props) {
    super(props);
    document.title = '填写退货信息';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.orderId = options.orderId
    this.franchiseeId = options.franchisee
    this.dataInitial()
  }

  componentDidMount() { }

  dataInitial = () => {
    this.getOrderDetail()
    this.expressList()
    this.getAppECStoreConfig()
    this.setData({
      phone: app.getUserInfo().phone || ''
    })
  }
  getOrderDetail = orderId => {
    var _this = this
    app.getOrderDetail({
      data: {
        order_id: _this.orderId,
        sub_shop_app_id: this.franchiseeId
      },
      success: function (res) {
        _this.applyId = res.data[0].form_data.refund_apply.id
        _this.setData({
          goodsList: res.data[0].form_data.refund_apply.refund_goods
        })
      }
    })
  }
  chooseImage = () => {
    let _this = this
    let img_arr = _this.data.imagesArr
    app.chooseImage(function (images) {
      let data = {}
      data.imagesArr = img_arr.concat(images)
      _this.setData(data)
    }, 9)
  }
  deleteImage = event => {
    let picIndex = event.currentTarget.dataset.index
    let img_arr = this.data.imagesArr
    let data = {}
    img_arr.splice(picIndex, 1)
    data.imagesArr = img_arr
    this.setData(data)
  }
  previewImage = event => {
    let _this = this
    let index = event.currentTarget.dataset.index
    app.previewImage({
      current: _this.data.imagesArr[index],
      urls: _this.data.imagesArr
    })
  }
  cancelRefund = () => {
    app.turnBack()
  }
  stopPropagation = event => { }
  inputRefundDes = event => {
    this.setData({
      refundDes: event.target.value
    })
  }
  shipmentNumber = event => {
    this.setData({
      shipment: event.target.value
    })
  }
  phoneNumber = event => {
    this.setData({
      phone: event.target.value
    })
  }
  sureSubmit = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=appShop/updateRefundApply',
      method: 'post',
      data: {
        sub_shop_app_id: this.franchiseeId,
        apply_id: _this.applyId,
        form_data: {
          express_code: _this.data.expressCode,
          express_no: _this.data.shipment,
          phone: _this.data.phone,
          description: _this.data.refundDes,
          img_url: _this.data.imagesArr
        }
      },
      success: function (res) {
        app.turnBack()
      }
    })
  }
  expressList = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=appShop/expressList',
      data: {
        page: -1
      },
      success: function (res) {
        _this.setData({
          expressList: res.data
        })
      }
    })
  }
  selectExpress = value => {
    this.setData({
      expressCode: value[0]
    })
  }
  scanLogisticsNumber = () => {
    let _this = this
    app.scanCode({
      success: function (res) {
        _this.setData({
          shipment: res.result
        })
      }
    })
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config,
        hasRecommendConfig: res.recommend_config ? true : false
      })
    }, this.franchiseeId)
  }

  render() {
    let {
      showGetUserInfo,
      goodsList,
      expressList,
      expressCode,
      shipment,
      phone,
      refundDes,
      imagesArr,
      storeStyle
    } = this.state

    // 转换成Picker所需要的数据
    if (expressList) {
      expressList = expressList.map((item) => ({
        label: item.name,
        value: item.code
      }))
    }

    return (
      <div className="official-page goods-return-infor">
        <TopNav title="填写退货信息" />
        <div className="refund-box">
          <div className="goods-detail-contain">
            {goodsList.map((goods, index) => {
              return (
                <div key className="goods-detail-box">
                  <img src={goods.cover} />
                  <div className="goods-detail-content">
                    <div className="goods-name">
                      {goods.is_seckill == 1 && (
                        <span className="is-seckill">秒杀</span>
                      )}
                      {goods.title}
                    </div>
                    {goods.model_name && (
                      <div className="goods-rules">{goods.model_name}</div>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
          <div className="logistics-box">
            <span className="logistics-title">物流公司</span>
            <span className="pull-right ico-moon icon-rightarrow"></span>
            <div className="pull-right">
              <Picker
                cols={1}
                extra="选择物流"
                data={expressList}
                value={[expressCode]}
                onChange={this.selectExpress}
              >
                <List.Item></List.Item>
              </Picker>
            </div>
          </div>
          <div className="logistics-box">
            <span className="logistics-title">物流单号</span>
            <span
              className="ico-moon icon-shopping-scan pull-right"
              onClick={this.scanLogisticsNumber}
            ></span>
            <input
              value={shipment}
              onChange={this.shipmentNumber}
              className="pull-right"
              type="text"
              placeholder="请填写物流单号"
            />
          </div>
          <div className="logistics-box logistics-contact">
            <span className="logistics-title">联系电话</span>
            <input
              onChange={this.phoneNumber}
              value={phone}
              className="pull-right"
              type="text"
              placeholder="请填写手机号码"
            />
          </div>
          <div className="refund-instruct">
            <div className="refund-instruct-title">
              退款说明<span>选填</span>
            </div>
            <textarea
              className="refund-des"
              value={refundDes}
              onInput={this.inputRefundDes}
            ></textarea>
            <div className="images-box">
              {imagesArr.map((item, index) => {
                return (
                  <div key={index}>
                    <span
                      className="delete-image ico-moon icon-closes"
                      onClick={this.deleteImage}
                      data-index={index}
                    ></span>
                    <img
                      src={item}
                      data-index={index}
                      onClick={this.previewImage}
                    />
                  </div>
                )
              })}
              <div className="add-pic" onClick={this.chooseImage}>
                <span className="ico-moon icon-goods-add-image"></span>
                <div>添加图片</div>
              </div>
            </div>
          </div>
          <div className="refund-bottom">
            <div className="refund-cancel" onClick={this.cancelRefund}>
              取消
            </div>
            <div
              className="refund-submit"
              style={convertLineStyleData('background:' + storeStyle.theme)}
              onClick={this.sureSubmit}
            >
              提交
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/goods-return-infor/GoodsReturnInfor.jsx